import { ENV } from "@vrf/fr-vrf-core";
import { Partner, SpreadSheetState } from "../partner-list";
import { CreateDeploymentRequestInterfacePartnerNamesRequest } from "../../services/deployment-request";

export const TEMPLATE_FILE_URL = "spreadsheet-template/partner-list-page.xlsx";

export const REQUEST_CD_TYPES = {
  IN_DEF_COMMON_FLAG_TYPE: "in_def_common_flag_type",
};

export const requestCdTypes = Object.values(REQUEST_CD_TYPES);

export const createDeploymentRequestParams = (
  spreadsheetState: SpreadSheetState,
  forceStgDplyFlg: boolean,
) => {
  const targetDataList: Partner[] = spreadsheetState.partnerList.filter(
    (e) => !!e.partnerInfo.ptnrNameWtngChng,
  );

  const partnerIdList = targetDataList.map((e) => ({
    partnerCode: e.partnerInfo.ptnrCd,
    partnerType: e.partnerInfo.ptnrTypeCd,
    partnerBuCd: e.partnerInfo.buCd,
    dipByRgn: e.partnerInfo.dipByRgn,
  }));

  const CreateDeploymentRequestInterfacePartnerNamesRequest: CreateDeploymentRequestInterfacePartnerNamesRequest =
    {
      dfnSetVerNum: ENV("REACT_APP_DFN_SET_VER_NUM"),
      forceStgDplyFlg: forceStgDplyFlg,
      partnerIdList: partnerIdList,
    };
  return CreateDeploymentRequestInterfacePartnerNamesRequest;
};
